// extracted by mini-css-extract-plugin
export default {"container":"QSHSB","content":"rVYeY","section":"E61Dp","sectionTitle":"TAnmf","sectionDescription":"GHpt+","separator":"NaJLs"};